/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Col_StockInputs */

const vi_tea_grade_col_stock = /** @type {(inputs: Tea_Grade_Col_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn kho (kg)`)
};

/**

* @param {Tea_Grade_Col_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_col_stock = /** @type {((inputs?: Tea_Grade_Col_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Col_StockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_col_stock(inputs)
});